import React, { Component } from 'react'

import YouTube from 'react-youtube'
import Date from '../../Date'

class VideoPlayer extends Component {

  _onReady(event) {
    // access to player in all event handlers via event.target
    //event.target.pauseVideo();
  }

  render() {
    const opts = {
      height: '390',
      width: '640',
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 1
      }
    };

    const { params, video } = this.props
    const { title, date } = video
    return (
      <div className="card">
        <div className="card-image">
          <div className="video-container">
            <YouTube
              videoId={params.id}
              opts={opts}
              onReady={this._onReady}
            />
          </div>
        </div>
        <div className="card-content">
          <p>
            <span className="card-title truncate">{ title }</span>
          </p>
          <p>
            <Date date={ date } withoutDay/>
          </p>
        </div>
      </div>
    )
  }

}

export default VideoPlayer


/** WEBPACK FOOTER **
 ** ./src/components/Media/Videos/VideoPlayer.jsx
 **/